import { render, staticRenderFns } from "./LcChopCountdown.vue?vue&type=template&id=5f8ade5c&"
import script from "./LcChopCountdown.vue?vue&type=script&lang=js&"
export * from "./LcChopCountdown.vue?vue&type=script&lang=js&"
import style0 from "./LcChopCountdown.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports